import { BASE_API_URL_CAP_DIEN } from "@utils/constants";

export const APITroNgai = {
  LIST_TRO_NGAI: `${BASE_API_URL_CAP_DIEN}/loai-tro-ngai/list`,
  CREATE_TRO_NGAI: `${BASE_API_URL_CAP_DIEN}/loai-tro-ngai/create`,
  UPDATE_TRO_NGAI: `${BASE_API_URL_CAP_DIEN}/loai-tro-ngai/update`,
  REMOVE_TRO_NGAI: `${BASE_API_URL_CAP_DIEN}/loai-tro-ngai/delete`,
};
